import { useExpressionScope } from '@formily/react';
import { IAnyObject } from '@yimoka/shared';
import { Entity } from '@yimoka/store';
import { useMemo } from 'react';

/**
 * 获取当前表达式作用域中的实体对象
 * @returns 当前作用域中的 Entity 实例
 */
export const useEntity = <V extends object = IAnyObject>() => {
  const scope = useExpressionScope();
  return useMemo(() => scope?.$entity as Entity<V> | undefined, [scope]);
};
